import { ReactNode } from 'react';
import { FormProvider, UseFormReturn, FieldValues } from 'react-hook-form';
import FormModal from './FormModal';

type ModalFormWrapperProps<T extends FieldValues> = {
  submitText: string;
  submitButton: 'default' | 'destructive';
  onSubmit: (data: T) => void;
  form: UseFormReturn<T>;
  onClose?: () => void;
  children: ReactNode;
};

export function ModalFormWrapper<T extends FieldValues>({ submitText, submitButton, onSubmit, form, onClose, children }: ModalFormWrapperProps<T>) {
  return (
    <FormProvider {...form}>
      <FormModal submitText={submitText} submitButton={submitButton} onSubmit={form.handleSubmit(onSubmit)} onClose={onClose}>
        {children}
      </FormModal>
    </FormProvider>
  );
}
